import { Routes, Route } from "react-router-dom";
import SharedLayout from "./pages/Global/SharedLayout/SharedLayout";
import RefereeGames from "./pages/Referee/RefereeGames";
import RefereePay from "./pages/Referee/RefereePay";
import RefereeCalendar from "./pages/Referee/RefereeCalendar";
import RefereeOverview from "./pages/Referee/RefereeOverview";
import AssignerDashboard from "./pages/Assigner/AssignerDashboard";
import AssignGames from "./pages/Assigner/AssignGames";
import AssignerReferees from "./pages/Assigner/AssignerReferees";
import AssignerPay from "./pages/Assigner/AssignerPay";
import ProtectedRoute from "./utils/ProtectedRoute";
import { useAppContext } from "./context/MainContext/AppContext";
import LandingPage from "./pages/Global/Login/LandingPage";
import RefereeFindGames from "./pages/Referee/RefereeFindGames";
import { Role } from "./context/MainContext/Constants";
import PrivacyPolicy from "./pages/Global/Login/PrivacyPolicy";
import SettingsPage from "./pages/Global/SettingsPage";
import Pricing from "./pages/Global/Pricing";
import Blog from "./pages/Global/Blog";
import Contact from "./pages/Global/Contact";
import Booking from "./pages/Global/Booking";
import NotFound from "./pages/Global/NotFound";

function App() {
  const { role, AssignerGameData, RefereeGameData, OrganizationData, getOrganizationData, getOrganizationGames, getGamesByUid } = useAppContext();

  switch (role) {
    case Role.Referee:
      break;
    case Role.Assigner:
      if (OrganizationData == null) {
        getOrganizationData();
      }
      break;
    default:
      break;
  }

  switch (role) {
    case Role.Referee:
      if (RefereeGameData == null) {
        getGamesByUid();
      }
      break;
    case Role.Assigner:
      if (AssignerGameData == null) {
        getOrganizationGames();
      }
      break;
    default:
      break;
  }

  return (
    <>
      <Routes>
        {/* Landing Page accessible to everyone */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/login" element={<Booking />} />
        <Route path="/signup" element={<Booking />} />
        <Route path="/reset" element={<Booking />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />

        {/* Routes for referees */}
        { role === Role.Referee && (
          <Route
            path="/referee"
            element={
              <ProtectedRoute>
                <SharedLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<RefereeOverview />} />
            <Route path="calendar" element={<RefereeCalendar />} />
            <Route path="pay" element={<RefereePay />} />
            <Route path="games" element={<RefereeGames />} />
            <Route path="findgames" element={<RefereeFindGames />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        )}

        {/* Routes for assigners */}
        { (role === Role.Assigner) && (
          <Route
            path="/assigner"
            element={
              <ProtectedRoute>
                <SharedLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AssignerDashboard />} />
            <Route path="assigngames" element={<AssignGames />} />
            <Route path="referees" element={<AssignerReferees />} />
            <Route path="pay" element={<AssignerPay />} />
          </Route>
        )}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
export default App;
